<p-toast></p-toast>
<p-toolbar styleClass="">
  <ng-template pTemplate="left">
    <p-button label="New" icon="pi pi-plus" styleClass="p-button-success mr-2" (onClick)="onCreateNewSalesLead($event)" [disabled]="false" pTooltip="Создать новую сделку/Зарегистрировать проект" tooltipPosition="top"></p-button>

    <app-confirm-delete-product-part [(display)]="confirmDeleteDocumentOn"
                                     [typeConfirmation]="true"
                                     [confirmText]="confirmDeleteDocumentText"
                                     (done)="onDeleteDocumentConfirmation($event)">
    </app-confirm-delete-product-part>

    <p-button label="Delete" icon="pi pi-trash" styleClass="p-button-danger" (onClick)="deleteSalesLead($event)"
            [disabled]="!salesLead" pTooltip="Удалить сделку" tooltipPosition="top"></p-button>

  </ng-template>

  <ng-template pTemplate="right">
    <p-button icon="pi pi-undo" label="Сбросить фильтр" styleClass="p-button-success mr-2" (onClick)="clearOrResetTableFilter($event)" pTooltip="Сбросить фильтр и вернуться в начало" tooltipPosition="top"></p-button>
    <p-button label="Обновить" icon="pi pi-refresh" styleClass="p-button-success mr-2" (click)="onReloadAllData($event)" pTooltip="Обновить список контрагентов" tooltipPosition="top"></p-button>
    <p-button label="Export" icon="pi pi-upload" styleClass="p-button-info" disabled="true"></p-button>
  </ng-template>
</p-toolbar>

<div *ngIf="salesLeads as leads else aloading">
  <p-table #dt
           [value]="leads"
           [lazy]="true"
           [loading]="loading"
           (onLazyLoad)="loadClientList($event)"
           [rows]="rows"
           [paginator]="true"
           [showCurrentPageReport]="true"
           [rowsPerPageOptions]="[10,25,50]"
           [totalRecords]="totalRecords"
           currentPageReportTemplate="Показано с {first} по {last} из {totalRecords} записей"
           [filterDelay]="200"
           [globalFilterFields]="['DOCREGNAME','DOCREGNOTE']"
           dataKey="DOCREGID"
           selectionMode="single"
           [(selection)]="salesLead"
           [rowHover]="true"
           styleClass="p-datatable p-datatable-gridlines p-datatable-striped "
           stateStorage="local"
           stateKey="salesLeadList-state"
           sortField="DOCREGCDATE"
           sortOrder="-1"
           (onFilter)="filterProdTable($event)"
           rowExpandMode="single"
           resizableColumns="true">

    <ng-template pTemplate="caption">
      <h3 class="ml-0 mr-auto do-not-wrap-text">Сделки</h3>
    </ng-template>

    <ng-template pTemplate="header">
      <tr style="">
        <th pResizableColumn style="width: 3rem !important">...</th>
        <th pResizableColumn pSortableColumn="DOCREGID" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 7% !important">Номер <p-sortIcon field="DOCREGID"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCREGCDATE" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 8% !important">Создан <p-sortIcon field="DOCREGCDATE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCREGNAME" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 25% !important">Название <p-sortIcon field="DOCREGNAME"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCREGNOTE" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: auto !important">Описание <p-sortIcon field="DOCREGNOTE"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCREGPERSONNAME" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 20% !important">Ответственный <p-sortIcon field="DOCREGPERSONNAME"></p-sortIcon></th>
        <th pResizableColumn pSortableColumn="DOCREGUDATE" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; width: 7% !important">Изменен <p-sortIcon field="DOCREGUDATE"></p-sortIcon></th>
      </tr>
      <tr>
        <th pResizableColumn style="width: 3rem">...</th>
        <th><input pInputText [(ngModel)]="cf01" type="number" (input)="dt.filter($event.target.value, 'DOCREGID', 'eq')" placeholder="Поиск" class="p-column-filter" [class.hasvalue]="cf01"></th>
        <th></th>
        <th><input pInputText [(ngModel)]="cf02" type="text" (input)="dt.filter($event.target.value, 'DOCREGNAME', 'contains')" placeholder="Поиск" class="p-column-filter" [class.hasvalue]="cf02"></th>
        <th><input pInputText [(ngModel)]="cf03" type="text" (input)="dt.filter($event.target.value, 'DOCREGNOTE', 'contains')" placeholder="Поиск" class="p-column-filter" [class.hasvalue]="cf03"></th>
        <th><input pInputText [(ngModel)]="cf04" type="text" (input)="dt.filter($event.target.value, 'DOCREGPERSONNAME', 'contains')" placeholder="Поиск" class="p-column-filter" [class.hasvalue]="cf04"></th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-leads let-expanded="expanded">
      <tr [pSelectableRow]="leads">
        <td>
          <button type="button" pButton pRipple [pRowToggler]="leads"
                  class="p-button-text p-button-rounded p-button-plain mt-1 mb-1"
                  [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
        </td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
          <a [routerLink]="['/edit-sales-lead', leads.DOCREGID]">{{leads.DOCREGID}}</a>
        </td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{leads.DOCREGCDATE | date:'dd.MM.yyyy'}}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{leads.DOCREGNAME}}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{leads.DOCREGNOTE}}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{leads.DOCREGPERSONNAME}}</td>
        <td style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{leads.DOCREGUDATE | date:'dd.MM.yyyy'}}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-leads>
      <tr>
        <td colspan="7">
          <div class="p-p-2">
            <app-list-sales-lead-items [salesLeadId]="leads.DOCREGID"></app-list-sales-lead-items>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7">Записей не найдено</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<ng-template #aloading>
  <p>Список загружается...</p>
</ng-template>

